// extracted by mini-css-extract-plugin
export var standaloneTable = "_eo-0";
export var standaloneTableWithBodyFill = "_eo-1";
export var withExtraHeader = "_eo-2";